export default function CTA() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-24 bg-gradient-to-br from-[#0A1F44] to-[#1E3A5F] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-64 h-64 bg-[#06B6D4] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#8B5CF6] rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h3 className="text-5xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
          Ready to Protect Your Privacy?
        </h3>

        <p className="text-xl text-gray-300 mb-10 leading-relaxed">
          Join thousands securing their digital life with enterprise-grade VPN protection
        </p>

        <button
          onClick={scrollToContact}
          className="group px-10 py-4 bg-white text-[#0A1F44] rounded-lg font-semibold text-lg hover:bg-gray-100 transition-all inline-flex items-center space-x-2 cursor-pointer whitespace-nowrap"
        >
          <span>Start Free Trial</span>
          <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
        </button>

        <p className="text-gray-400 text-sm mt-4">
          No credit card required
        </p>
      </div>
    </section>
  );
}
